import {useContext} from 'react';
import ModalContext from './ModalContext';

function useModal() {
  const {openModal, closeModal, closeAllModal} = useContext(ModalContext);

  return {
    openModal,
    closeModal,
    closeAllModal,
  };
}

export default useModal;
